import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAdvertisingAccounts(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/advertising_management/advertising_accounts/`,
    oauthTokenHeader,
  );
}
function getAdAccountDetails(
  oauthTokenHeader: string,
  traffic_shared_uid: string,
  ad_account_id: string,
  ad_companies_id?: string, // optional
) {
  let url = `${apiUrl}/advertising_management/ad_account_details/?traffic_source=${traffic_shared_uid}&account_id=${ad_account_id}`;

  if (ad_companies_id) {
    url += `&advertising_company_shared_uid=${ad_companies_id}`;
  }

  return fetchWrapper.get(url, oauthTokenHeader);
}

function updateAdAccount(
  page_shared_uid: string,
  oauthTokenHeader: string,
  data: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/advertising_management/advertising_accounts/${page_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function createAdAccount(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/advertising_accounts/`,
    data,
    oauthTokenHeader,
  );
}

function createAuctionInsight(oauthTokenHeader: string, data: any) {
  return fetchWrapper.postForCSV(
    `${apiUrl}/auction_insights/upload/`,
    data,
    oauthTokenHeader,
  );
}
function updateAssetLinks(
  oauthTokenHeader: string,
  data: any,
  account_shared_uid: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/advertising_management/advertising_accounts/asset_link/${account_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}
function postAdAccountDetails(
  oauthTokenHeader: string,
  data: any,
  account_uid: string,
) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/ad_account_details/${account_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function getSingleAdvertisingAccount(
  account_shared_uid: string,
  oauthTokenHeader: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/advertising_management/advertising_accounts/${account_shared_uid}/`,
    oauthTokenHeader,
  );
}

function postWebsiteToAccount(
  oauthTokenHeader: string,
  data: any,
  account_shared_uid: any,
) {
  return fetchWrapper.post(
    `${apiUrl}/advertising_management/advertising_accounts/asset_link/${account_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function getTerritories(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/territories/`, oauthTokenHeader);
}

function advertisingAccountsToggle(
  oauthTokenHeader: string,
  data: any,
  account_shared_uid: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/advertising_management/advertising_accounts/toggle/${account_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

function getTrafficSource(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/traffic_sources/`, oauthTokenHeader);
}

function getGeo(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/geos/`, oauthTokenHeader);
}
function postGeo(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(`${apiUrl}/meta/geos/`, data, oauthTokenHeader);
}
function getIndustries(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/industries/`, oauthTokenHeader);
}

function postIndustry(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/meta/industries/`,
    data,
    oauthTokenHeader,
  );
}

function getCompanies(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/advertising_management/ads_companies/`,
    oauthTokenHeader,
  );
}

export const advertisingAccountsService = {
  getAdvertisingAccounts,
  getAdAccountDetails,
  updateAdAccount,
  createAdAccount,
  createAuctionInsight,
  updateAssetLinks,
  postAdAccountDetails,
  getSingleAdvertisingAccount,
  postWebsiteToAccount,
  getTerritories,
  advertisingAccountsToggle,
  getTrafficSource,
  getGeo,
  postGeo,
  getIndustries,
  postIndustry,
  getCompanies,
};
